module.exports = __webpack_public_path__ + "static/media/woman_04.b1a7a0d6.png";